module.exports = __webpack_public_path__ + "static/media/Crescendo-fuzzyraven361.e3dba8cd.jpg";